var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCategoriesFilled(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.5 13.494h8v8a8 8 0 01-8-8zm11 8h0a8 8 0 008-8h-8zM2.5 6.5h0a4 4 0 104-4 4 4 0 00-4 4zm11 3.994h8a8 8 0 00-8-8z",
    fill: "#000450",
    stroke: "#000450"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M0 0h24v24H0z"
  })));
}
export default "data:image/svg+xml;base64,PHN2ZyBpZD0iQ2F0ZWdvcmllcyIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIiB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCI+CiAgPHBhdGggaWQ9Ikljb24iIGQ9Ik0yLjUsMTMuNDk0aDh2OEE4LDgsMCwwLDEsMi41LDEzLjQ5NFptMTEsOGgwYTgsOCwwLDAsMCw4LThoLThaTTIuNSw2LjVoMGE0LDQsMCwxLDAsNC00QTQsNCwwLDAsMCwyLjUsNi41Wm0xMSwzLjk5NGg4YTgsOCwwLDAsMC04LThaIiBmaWxsPSIjMDAwNDUwIiBzdHJva2U9IiMwMDA0NTAiIHN0cm9rZS13aWR0aD0iMSIvPgogIDxyZWN0IGlkPSJDb250YWluZXIiIHdpZHRoPSIyNCIgaGVpZ2h0PSIyNCIgZmlsbD0ibm9uZSIvPgo8L3N2Zz4K";
export { SvgCategoriesFilled as ReactComponent };